import { Component, Input } from '@angular/core';
import { ProvidersService } from 'fccore2';
import { FcinputComponent } from '../fcinput';
/**
 * fc-labelææ¬
 * 
 * ææ¬ç»ä»¶ã
 * 
 * æè¿°ä¸ä¸ªinputæ¡çæå­ã
 * 
 */
@Component({
    selector: 'fc-label',
    template: `
    <div nz-row  nzType="flex" class="rowspans" [ngClass]="{}" *ngIf="fcShowLabel===undefined||fcShowLabel==='Y'" (blur)="_blur($event)">
        <div nz-col [nzSpan]="labelSpan" class="labelspans"><span *ngIf="fcRequired==='Y'" style="color:red">*</span>{{fcLabel}}</div>
        <div nz-col [nzSpan]="valueSpan">{{fcValue}}</div>
    </div>
    `,
    styles: [`
    .content_font{
        font-size:16px;
        display:inline-block;
        color:#333;
    }
    `]
})
export class FclabelComponent extends FcinputComponent {
     /**åç§°*/
    @Input()
    fcLabel: string;
     /**åå®¹*/
    @Input()
    fcValue: string;
    constructor(public provider: ProvidersService) {
        super(provider, 'fc-label');
    }
}


